<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Salary Billing Rate Contract</title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
    <style>
        body {
            background-color: #d9ebf1;
        }

        .section-title {
            background-color: #e8f2f9;
            padding: 6px 12px;
            border-radius: 4px;
            font-weight: 600;
        }

        .table thead th {
            background-color: #f0f6fb;
            text-align: center;
        }

        .summary-box {
            background-color: #e0f2f9;
            border-radius: 5px;
            padding: 10px;
        }

        .form-label {
            font-weight: 500;
        }

        .right-panel {
            background: #f8fbfd;
            border: 1px solid #c9e0ea;
            border-radius: 6px;
            padding: 10px;
        }
    </style>
</head>

<body class="p-3">

    <div class="container-fluid">
        <h4 class="text-center mb-4">Salary Billing Rate Contract</h4>

        <div class="card shadow-sm mb-3">
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-md-2">
                        <label class="form-label">Month / Year</label>
                        <input type="month" class="form-control" value="2025-11">
                    </div>
                    <div class="col-md-5">
                        <label class="form-label">Client Group</label>
                        <input type="text" class="form-control" value="AHMEDABAD INTERNATIONAL AIRPORT LIMITED">
                    </div>
                    <div class="col-md-5">
                        <label class="form-label">Select Group</label>
                        <input type="text" class="form-control" value="AHMEDABAD INTERNATIONAL AIRPORT - AHMEDABAD">
                    </div>
                    <div class="col-md-5">
                        <label class="form-label">Designation</label>
                        <input type="text" class="form-control" value="JANITOR">
                    </div>
                    <div class="col-md-5">
                        <label class="form-label">Select Duty</label>
                        <select class="form-select">
                            <option selected>9 HOURS</option>
                        </select>
                    </div>
                    <div class="col-md-2 d-flex align-items-end">
                        <button class="btn btn-success w-100">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-3">
                <input class="form-control form-control-sm" value="CLR/MUM/04102025/46017" disabled>
            </div>
            <div class="col-md-5 d-flex">
                <label class="form-label">Attachmemt: </label>
                <input class="form-control form-control-sm" style="width: auto;" value="" disabled>
                <button class="btn btn-secondary me-2"><i class="bi bi-file-earmark"></i> View</button>
                <button class="btn btn-secondary"><i class="bi bi-paperclip"></i> Attach</button>
            </div>
            <div class="col-md-4 d-flex align-items-end justify-content-end">
                <button class="btn btn-outline-primary me-2"><i class="bi bi-currency-rupee"></i> Previous Rate</button>
                <button class="btn btn-outline-primary"><i class="bi bi-calculator"></i> Calcultion</button>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm mb-3">
                    <div class="card-body">
                        <div class="section-title mb-2">
                            <div class="row">
                                <div class="col">
                                    Salary Head Details
                                </div>
                                <div class="col-5 d-flex align-items-end">
                                    <label class="form-label">Salary Head: </label>
                                    <select class="form-select mx-1" style="width:18rem">
                                        <option selected></option>
                                    </select>
                                    <button class="btn btn-success"><i class="bi bi-plus"></i> Add</button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-sm align-middle text-center">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Salary Head Name</th>
                                        <th>B Computation</th>
                                        <th>B %</th>
                                        <th>B Formula</th>
                                        <th>B Amount</th>
                                        <th>B Monthly / Yearly</th>
                                        <th>B MaxAmount</th>
                                        <th>S Computation</th>
                                        <th>S %</th>
                                        <th>S Formula</th>
                                        <th>S Amount</th>
                                        <th>S Monthly / Yearly</th>
                                        <th>S MaxAmount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>BA</td>
                                        <td>BASIC</td>
                                        <td class="thbilling" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Pro-Rated</option>
                                            </select>
                                        </td>
                                        <td class="thbilling text-end">0</td>
                                        <td class="thbilling"></td>
                                        <td class="thbilling text-end">20930</td>
                                        <td class="thbilling" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Monthly</option>
                                            </select>
                                        </td>
                                        <td class="thbilling"></td>
                                        <td class="thsalary" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Pro-Rated</option>
                                            </select>
                                        </td>
                                        <td class="thsalary"></td>
                                        <td class="thsalary"></td>
                                        <td class="thsalary text-end">20930</td>
                                        <td class="thsalary" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Monthly</option>
                                            </select>
                                        </td>
                                        <td class="thsalary"></td>
                                    </tr>
                                    <tr>
                                        <td>DA</td>
                                        <td>DA</td>
                                        <td class="thbilling" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Pro-Rated</option>
                                            </select>
                                        </td>
                                        <td class="thbilling text-end">0</td>
                                        <td class="thbilling"></td>
                                        <td class="thbilling text-end">2000</td>
                                        <td class="thbilling" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Monthly</option>
                                            </select>
                                        </td>
                                        <td class="thbilling"></td>
                                        <td class="thsalary" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Pro-Rated</option>
                                            </select>
                                        </td>
                                        <td class="thsalary"></td>
                                        <td class="thsalary"></td>
                                        <td class="thsalary text-end">2000</td>
                                        <td class="thsalary" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Monthly</option>
                                            </select>
                                        </td>
                                        <td class="thsalary"></td>
                                    </tr>
                                    <tr>
                                        <td>HRA</td>
                                        <td>HRA</td>
                                        <td class="thbilling" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Pro-Rated</option>
                                            </select>
                                        </td>
                                        <td class="thbilling text-end">0</td>
                                        <td class="thbilling"></td>
                                        <td class="thbilling text-end">500</td>
                                        <td class="thbilling" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Monthly</option>
                                            </select>
                                        </td>
                                        <td class="thbilling"></td>
                                        <td class="thsalary" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Pro-Rated</option>
                                            </select>
                                        </td>
                                        <td class="thsalary"></td>
                                        <td class="thsalary"></td>
                                        <td class="thsalary text-end">500</td>
                                        <td class="thsalary" style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 7rem;">
                                                <option selected>Monthly</option>
                                            </select>
                                        </td>
                                        <td class="thsalary"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="card shadow-sm mb-3">
                    <div class="card-body">
                        <div class="section-title mb-2">Additional Heads</div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-sm text-center">
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Head Name</th>
                                        <th style="width:11rem">Computation</th>
                                        <th>%</th>
                                        <th>Formula</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>UNI</td>
                                        <td>UNIFORM</td>
                                        <td style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 8rem;">
                                                <option selected>Fixed Value</option>
                                            </select>
                                        </td>
                                        <td class="text-end">0</td>
                                        <td></td>
                                        <td class="text-end">300.00</td>
                                    </tr>
                                    <tr>
                                        <td>MED</td>
                                        <td>MEDICLAIM</td>
                                        <td style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 8rem;">
                                                <option selected>Fixed Value</option>
                                            </select>
                                        </td>
                                        <td class="text-end">0</td>
                                        <td></td>
                                        <td class="text-end">150.00</td>
                                    </tr>
                                    <tr>
                                        <td>OVH</td>
                                        <td>OPERATIONS & OVERHEADS</td>
                                        <td style="place-items:center">
                                            <select class="form-select form-select-sm" style="width: 8rem;">
                                                <option selected>Fixed Value</option>
                                            </select>
                                        </td>
                                        <td class="text-end">0</td>
                                        <td></td>
                                        <td class="text-end">50.00</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-md-12">
                <div class="right-panel mb-3">
                    <div class="row">
                        <div class="col-md-4">
                            <h6 class="section-title">OT Details (Salary)</h6>
                            <div class="mb-2">
                                <label class="form-label">OT Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="2.00">
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="form-label">Formula</label>
                                <label class="form-label" style="float: right;"><i
                                        class="bi bi-plus-square-fill"></i></label>
                                <input type="text" class="form-control form-control-sm" value="BA+DA">
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Fixed Value</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="26.00">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h6 class="section-title">Special OT Details (Salary)</h6>
                            <div class="mb-2">
                                <label class="form-label">OT Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="form-label">Formula</label>
                                <label class="form-label" style="float: right;"><i
                                        class="bi bi-plus-square-fill"></i></label>
                                <input type="text" class="form-control form-control-sm" value="">
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Fixed Value</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h6 class="section-title">Week Off Details (Salary)</h6>
                            <div class="mb-2">
                                <label class="form-label">WO Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="form-label">Formula</label>
                                <label class="form-label" style="float: right;"><i
                                        class="bi bi-plus-square-fill"></i></label>
                                <input type="text" class="form-control form-control-sm" value="">
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Fixed Value</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-4">
                            <h6 class="section-title">Paid Leave Details (Salary)</h6>
                            <div class="mb-2">
                                <label class="form-label">Leave Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="form-label">Formula</label>
                                <label class="form-label" style="float: right;"><i
                                        class="bi bi-plus-square-fill"></i></label>
                                <input type="text" class="form-control form-control-sm" value="">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h6 class="section-title">Paid Holiday Details (Salary)</h6>
                            <div class="mb-2">
                                <label class="form-label">Holiday Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Formula</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="form-label">Formula</label>
                                <label class="form-label" style="float: right;"><i
                                        class="bi bi-plus-square-fill"></i></label>
                                <input type="text" class="form-control form-control-sm" value="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="right-panel mb-3">
                    <div class="row">
                        <div class="col-md-4">
                            <h6 class="section-title">OT Details (Billing)</h6>
                            <div class="mb-2">
                                <label class="form-label">OT Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>OnAmount</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="15000.00">
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">OT Calculation On</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Total Month Days</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <h6 class="section-title">NH Details (Billing)</h6>
                            <div class="mb-2">
                                <label class="form-label">MH Type</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Fix Value</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">NH Calculation On</label>
                                <div class="d-flex">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Total Month Days</option>
                                    </select>
                                    <input type="number" class="form-control form-control-sm" value="0.00">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-md-3 summary-box">
                <div class="d-flex"><b>Total:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm"
                        value="30421.31">
                </div>
                <div class="d-flex"><b>Gross Total:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm"
                        value="25340.07">
                </div>
            </div>
            <div class="col-md-3 summary-box">
                <div class="d-flex"><b>Net Total:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm"
                        value="23540.07">
                </div>
                <div class="d-flex"><b>CTC Total:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm"
                        value="29569.31">
                </div>
            </div>
            <div class="col-md-3 summary-box">
                <div class="d-flex"><b>Round Off:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm" value="-0.91">
                </div>
                <div class="d-flex"><b>Billing Total:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm"
                        value="30420.40">
                </div>
            </div>
            <div class="col-md-3 summary-box">
                <div class="d-flex"><b>Bench Mark:</b>
                    <input type="number" style="width:fit-content" class="form-control form-control-sm" value="2.80">
                </div>
            </div>
        </div>

        <div class="text-center mt-4">
            <button class="btn btn-danger me-2"><i class="bi bi-search"></i> Find</button>
            <button class="btn btn-warning me-2"><i class="bi bi-pencil-square"></i> Edit</button>
            <button class="btn btn-primary me-2"><i class="bi bi-check-circle"></i> Save</button>
            <button class="btn btn-secondary me-2"><i class="bi bi-x-circle"></i> Cancel</button>
            <button class="btn btn-info me-2"><i class="bi bi-copy"></i> Copy</button>
            <button class="btn btn-dark me-2"><i class="bi bi-printer"></i> Print</button>
            <button class="btn btn-success"><i class="bi bi-file-earmark-spreadsheet"></i> Export to Excel</button>
        </div>
    </div>

    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
</body>

</html>


<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Employee Salary Structure</title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
    <style>
        body {
            background-color: #f8f6f0;
            font-size: 14px;
        }

        .section-title {
            background-color: #e8f2f9;
            padding: 6px 12px;
            border-radius: 4px;
            font-weight: 600;
        }

        .table thead th {
            background-color: #f0f6fb;
            text-align: center;
            vertical-align: middle;
        }

        .summary-box {
            background-color: #e0f2f9;
            border-radius: 5px;
            padding: 10px;
        }

        .form-label {
            font-weight: 500;
        }

        .bottom-bar {
            background: #dfeef5;
            border-radius: 6px;
            padding: 10px;
        }

        .btn i {
            margin-right: 4px;
        }
    </style>
</head>

<body class="p-3">

    <div class="container-fluid">
        <h5 class="text-center mb-4 fw-bold">Employee Salary Structure</h5>

        <!-- Employee Selection -->
        <div class="card shadow-sm mb-3">
            <div class="card-body">
                <div class="row g-3 align-items-end">
                    <div class="col-md-4">
                        <label class="form-label">Select Employee</label>
                        <select class="form-select">
                            <option selected>DMCNP21394</option>
                            <option>DMCNP21395</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">&nbsp;</label>
                        <input type="text" class="form-control" value="GAYATRI BHOSALE" readonly>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label">Month / Year</label>
                        <input type="month" class="form-control" value="2025-10">
                    </div>
                </div>
            </div>
        </div>

        <!-- Salary Head Table -->
        <div class="card shadow-sm mb-3">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-bordered table-sm align-middle text-center">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Salary Head Name</th>
                                <th style="width:10rem">Computation</th>
                                <th>Percentage</th>
                                <th>Formula</th>
                                <th>Amount</th>
                                <th style="width:8rem">Monthly/Yearly</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>STP</td>
                                <td>STIPEND</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Pro-Rated</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">16500.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Monthly</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>ARMA LW</td>
                                <td>ADMISSION FEES</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Fixed Value</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">0.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Yearly</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>SHOE</td>
                                <td>SHOES CHARGES</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Fixed Value</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">0.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Yearly</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>INS</td>
                                <td>INSURANCE CHARGES</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Fixed Value</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">0.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Yearly</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>SOU</td>
                                <td>SOURCING CHARGES</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Fixed Value</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">0.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Yearly</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>TSHIRT</td>
                                <td>TSHIRT CHARGES</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Fixed Value</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">0.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Yearly</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>GOG</td>
                                <td>GOGGLE CHARGES</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 8rem;">
                                        <option selected>Fixed Value</option>
                                    </select>
                                </td>
                                <td class="text-end">0</td>
                                <td></td>
                                <td class="text-end">0.00</td>
                                <td style="place-items:center">
                                    <select class="form-select form-select-sm" style="width: 7rem;">
                                        <option selected>Yearly</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- OT and Leave Details -->
        <div class="card shadow-sm mb-3">
            <div class="card-body">
                <div class="row g-3">
                    <!-- OT Details -->
                    <div class="col-md-4">
                        <h6 class="section-title">OT Details</h6>
                        <div class="mb-2">
                            <label class="form-label">OT Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Formula</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="2.00">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" value="BA+DA">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Formula</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="26.00">
                            </div>
                        </div>
                    </div>

                    <!-- Special OT Details -->
                    <div class="col-md-4">
                        <h6 class="section-title">Special OT Details</h6>
                        <div class="mb-2">
                            <label class="form-label">OT Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Formula</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="0.00">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" value="">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Formula</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="0.00">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Week Off / Leave / Holiday -->
                <div class="row g-3 mt-3">
                    <div class="col-md-4">
                        <h6 class="section-title">Week Off Details</h6>
                        <div class="mb-2">
                            <label class="form-label">WO Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Fixed Value</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="0.00">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" value="">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Formula</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="0.00">
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <h6 class="section-title">Paid Leave Details</h6>
                        <div class="mb-2">
                            <label class="form-label">Leave Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Fixed Value</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="0.00">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" value="">
                        </div>
                    </div>

                    <div class="col-md-4">
                        <h6 class="section-title">Paid Holiday Details</h6>
                        <div class="mb-2">
                            <label class="form-label">Holiday Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 7rem;">
                                    <option selected>Fixed Value</option>
                                </select>
                                <input type="number" class="form-control form-control-sm" value="0.00">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" value="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Summary and Buttons -->
        <div class="bottom-bar mt-3">
            <div class="row align-items-center">
                <div class="col-md-8 text-center">
                    <button class="btn btn-danger me-1"><i class="bi bi-search"></i>Find</button>
                    <button class="btn btn-warning me-1"><i class="bi bi-pencil-square"></i>Edit</button>
                    <button class="btn btn-primary me-1"><i class="bi bi-check-circle"></i>Save</button>
                    <button class="btn btn-secondary me-1"><i class="bi bi-x-circle"></i>Cancel</button>
                    <button class="btn btn-info me-1"><i class="bi bi-file-earmark-excel"></i>Excel</button>
                    <button class="btn btn-success me-1"><i class="bi bi-printer"></i>Print</button>
                </div>
                <div class="col-md-4 text-end">
                    <b>Gross Total:</b> <span class="me-4">16500</span>
                    <b>Total CTC:</b> <span>16500</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Bootstrap Icons + JS -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
</body>

</html>